export default player => {
  player.on('ready', () => {
    if (!player?.config?.logo || player?.config?.logo_added) {
      return;
    }
    if (player.isAudio) return;

    const controlsElement = player?.elements?.controls;
    console.log(controlsElement);
    if (!controlsElement || !controlsElement.parentNode) {
      return;
    }

    const logoImage = document.createElement('img');
    logoImage.src = player?.config?.logo;
    logoImage.className = 'presto-player__logo is-bottom-right';
    logoImage.setAttribute('part', 'logo');

    controlsElement.parentNode.insertBefore(logoImage, controlsElement);

    player.config.logo_added = true;
  });
};
